import {
    AVAILABILITY_ERROR,
    AVAILABILITY_FETCH_START,
    AVAILABILITY_FETCH_SUCCESS,
    AVAILABILITY_GET_NEXT_DATE_START,
    AVAILABILITY_GET_NEXT_DATE_SUCCESS,
    AvailabilityAction
} from 'actions/availability/AvailabilityActionsTypes';
import { AvailabilityState, AvailabilityStatus } from 'reducers/availability/AvailabilityState';
import { Reducer } from 'redux';

const initialState: AvailabilityState = {
    availableHours: [],
    status: AvailabilityStatus.Initial,
    loading: false
};

export const availabilityReducer: Reducer<AvailabilityState, AvailabilityAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case AVAILABILITY_FETCH_START:
            return {
                ...state,
                loading: true,
                status: AvailabilityStatus.FetchStart
            };
        case AVAILABILITY_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                availableHours: action.payload.availableHours,
                status: AvailabilityStatus.FetchSuccess
            };
        case AVAILABILITY_GET_NEXT_DATE_START:
            return {
                ...state,
                loading: true,
                status: AvailabilityStatus.GetNextDateStart
            };
        case AVAILABILITY_GET_NEXT_DATE_SUCCESS:
            return {
                ...state,
                loading: false,
                availableHours: action.payload.availableHours,
                status: AvailabilityStatus.GetNextDateSuccess
            };
        case AVAILABILITY_ERROR:
            return {
                ...state,
                loading: false,
                status: AvailabilityStatus.Error
            };
        default:
            return state;
    }
};
